const HEADINGS_DROPDOWN_TYPE = "wix-rich-content-plugin-headings";
export {
  HEADINGS_DROPDOWN_TYPE
};
//# sourceMappingURL=types.js.map
